import { render, staticRenderFns } from "./AdRevenueBreakdown.vue?vue&type=template&id=4ccb34e1&"
import script from "./AdRevenueBreakdown.vue?vue&type=script&lang=js&"
export * from "./AdRevenueBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports